/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import {Integrations} from "@sentry/tracing";
import {VueMaskDirective} from 'v-mask'
import { createPinia, PiniaVuePlugin } from 'pinia'
import {useUserStore} from "./stores/user";
import UUID from "vue-uuid";



if (env !== 'local') {
    Sentry.init({
                    dsn: "https://23a5722a87b3497cab42b1bfaf0f6cfb@o334205.ingest.sentry.io/5822083",
                    integrations: [new Integrations.BrowserTracing()],
                    ignoreErrors: [
                        "Non-Error promise rejection captured",
                    ],

                    // We recommend adjusting this value in production, or using tracesSampler
                    // for finer control
                    tracesSampleRate: 1.0,
                    beforeSend: (event) => {
                        // Ignore IE 11, but gather Edge errors
                        if ('ActiveXObject' in window) return null;
                        return event;
                    }
                });
}

require('./bootstrap');

// Responsible for making the material labels move upwards when there's content in the input
function addClassToFilledInputs(input) {
    // check if the input has any value (if we've typed into it)
    if ($(input).val())
        $(input).addClass('used');
    else
        $(input).removeClass('used');
}

function findInputsAndAddClasses() {
    $('input, textarea, select').each(function (e) {
        addClassToFilledInputs(e);
    })
}

$(document).ready(function () {
    // If the page has refreshed with old input values, we'll make sure the labels move up.
    $('input, textarea, select').each(function () {
        addClassToFilledInputs(this);
    });

    $(document).on('blur', 'input, textarea, select', function () {
        addClassToFilledInputs(this);
    });

    $(document).on('input', 'select', function () {
        addClassToFilledInputs(this);
    });

    $(document).on('findInputsAndAddClasses', 'select', function () {
        findInputsAndAddClasses();
    });
});

Vue.directive('mask', VueMaskDirective);

export const formattedPrice = function (cents, currency = "USD") {
    const dollars = cents / 100;
    return dollars.toLocaleString("en-US", {style: "currency", currency: currency});
}

Vue.filter('formattedPrice', formattedPrice)

Vue.component('shipping-form', require('./components/ShippingForm').default);
Vue.component('shipping-order-form', require('./components/ShippingOrderForm').default);
Vue.component('shipping-rates', require('./components/ShippingRates').default);
Vue.component('shipping-details', require('./components/ShippingDetails').default);
Vue.component('pickup-form', require('./components/PickupForm').default);
Vue.component('pricing-calculator', require('./components/PricingCalculator').default);
Vue.component('pricing-rows', require('./components/PricingRows').default);
Vue.component('loader', require('./components/Loader').default);
Vue.component('steps', require('./components/Steps').default);
Vue.component('credit-card', require('./components/CreditCardForm').default);
Vue.component('shipping-purchase', require('./components/ShippingPurchase').default);
Vue.component('loading-button', require('./components/LoadingButton').default);
Vue.component('shipping-rate', require('./components/ShippingRate').default);
Vue.component('panel', require('./components/Panel').default);
Vue.component('legal-form', require('./components/LegalForm').default);
Vue.component('modal', require('./components/Modal').default);
Vue.component('accordion', require('./components/Accordion/Accordion.vue').default);
Vue.component('accordion-item', require('./components/Accordion/AccordionItem.vue').default);
Vue.component('shipment-form-fields', require('./components/ShipmentFormFields.vue').default);
Vue.component('button-outline', require('./components/ButtonOutline.vue').default);
Vue.component('order-purchase', require('./components/OrderPurchase.vue').default);
Vue.component('shipment', require('./components/Shipment.vue').default);
Vue.component('grey-box', require('./components/GreyBox.vue').default);
Vue.component('csv-parser', require('./components/CsvParser.vue').default);

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(UUID);

axios.defaults.headers.common = {
    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
};

const app = new Vue({
                        el: '#page',
                        mounted() {
                        },
                        methods: {},
                        pinia,
                    });
